export const firebaseConfig = {
  apiKey: 'AIzaSyA65oHvFk4M9S1_1ZkqTErPVXTX2_8GItU',
  authDomain: 'sensei-dev-1.firebaseapp.com',
  databaseURL: 'https://sensei-dev-1.firebaseio.com',
  projectId: 'sensei-dev-1',
  storageBucket: 'sensei-dev-1.appspot.com',
  messagingSenderId: '7200005627',
  appId: '1:7200005627:web:0ef501415b1615bb4cff5e',
};
